import { createContext } from "react";

export interface LanguageContextType {
  language: "en" | "id";
  setLanguage: (lang: "en" | "id") => void;
  t: (key: string) => string;
}

export const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
